import { useState, useEffect } from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { ApiStatus } from "./ApiStatus";
import { getAppName } from "@/utils/appConfig";

export const Footer = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-sm border-t border-border z-40">
      <div className="container mx-auto px-6 h-12 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 bg-gradient-primary rounded-md flex items-center justify-center">
            <svg
              className="w-3 h-3 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
          </div>
          <span className="font-semibold text-sm bg-gradient-primary bg-clip-text text-transparent">
            {getAppName()} © {new Date().getFullYear()}
          </span>
        </div>

        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          {/* Status da API */}
          <ApiStatus />

          <div className="flex items-center space-x-2">
            <span>
              {format(currentTime, "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}
            </span>
            <span className="text-border">•</span>
            <span className="font-mono text-primary font-medium">
              {format(currentTime, "HH:mm:ss")}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
